<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" id="benefitHeader">
                    {{pageTitle}}
                </div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="changeProfile">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Category-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              @change="changedValueLoc"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationType">Location Type :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationType"
                                              name="locationType"
                                              id="locationType"
                                              label="text"
                                              :clearable="false"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="locationTypeArr"
                                              placeholder="Select Location Type">
                                    </v-select>
                                </div>
                            </div>
                            <!--Button Title-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="videoTitle">Button Title :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="videoTitle" type="text" class="form-control" id="videoTitle" placeholder="Button Title">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{buttonTitleError}}</font>
                                </div>
                            </div>

                            <!--Video-->
                            <!--<div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="videoTitle">Upload Video :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-duplicate-file="vduplicateFile"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <font class="text-danger"> <strong id="errorMsg1" class="error text-danger"></strong></font>
                                </div>
                            </div>-->
                            <!--Video-->
                            <div class="col-6 forms-block" id="myForm">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="videoTitle">Type :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <label><input type="radio" name="cars" value="2" checked="checked" />Upload Doc</label>
                                    <label><input type="radio" name="cars" value="3" />Enter URL</label>
                                </div>
                            </div>
                            <!--Enter Manually-->
                            <div id="uploadSelected2" class="row col-12 desc">
                                <div class="col-12 forms-block" id="myForm">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label" for="videoTitle">Upload Document :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <vue-dropzone
                                            id="drop1"
                                            :options="dropzoneOptions"
                                            ref="dropzone"
                                            :destroyDropzone="false"
                                            :headers="dropzoneOptions.headers"
                                            @vdropzone-removed-file="removedSelectedFile"
                                            @vdropzone-success="vfileSuccess"
                                            @vdropzone-duplicate-file="vduplicateFile"
                                            @vdropzone-total-upload-progress="progressOfUload"
                                            name="file"
                                            >
                                        </vue-dropzone>
                                        <font class="text-danger">{{videoURLError}}</font>
                                        <font class="text-danger"> <strong id="errorMsg2" class="error text-danger"></strong></font>
                                    </div>
                                </div>
                            </div>

                            <!--Enter Video URL-->
                            <div div id="uploadSelected3" class="row col-12 desc" style="display: none;">
                                <div class="col-12 forms-block" id="myForm">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label" for="videoURL">Button URL :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input v-model="videoURL" type="text" class="form-control" id="videoURL" placeholder="Button URL">
                                        <font class="text-danger">{{videoURLError}}</font>
                                    </div>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addBenefitGlance()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addBenefitGlance(flag='Save and Continue')">
                                    <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addBenefitGlance()"></input>-->
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <!--page content-->
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import VueCroppie from 'vue-croppie';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import tinymce from 'vue-tinymce-editor';
    import axios from 'axios';

    Vue.use(VueCroppie);
    export default {
        name: 'Login',
        props: [''],
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            'tinymce': tinymce,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                locationType: {value: 'other', text: 'Other'},
                locationTypeArr: [
                    {value: 'other', text: 'Other'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".pdf, .doc, .docx",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only {{maxFiles}} file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },

                docType: '',
                docSize: '',
                docPaths: '',
                videoURL: '',
//                V-model
                categoryId: '',
                categoryArr: [],
                locationId: '',
                locationArr: [],
                roleId: 0,
                roleArr: [],
                videoTitle: '',
                selectedRadioButton: '',
                pageTitle: 'Add Benefit Glance',

//                FrontEnd Errors
                categoryError: '',
                locationError: '',
                buttonTitleError: '',
                videoURLError: '',
                roleError: '',
                isFileUploaded: false,
                fileUploaded: true,
                isDocLoaded: false,

//                BackEnd Error
                backendErrors: [],
            }
        },
        mounted: function () {
            self = this;
            self.showLoader();
            /*self.loadCategory();*/
            self.loadLocationsAdd();
            /*self.loadRole();
             self.loadLocations();*/

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updatebenefitglance') {
                if (segments[3]) {
                    self.loadBenefitGlance();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit Benefit Glance";
                }
            } else {
                self.selectedRadioButton = 2;
            }

            $(document).ready(function () {
                $("input[name$='cars']").click(function () {
                    var test = $(this).val();

                    $("div.desc").hide();
                    $("#uploadSelected" + test).show();
                    self.videoURLError = "";
                });
            });

            $('#myForm input').on('change', function () {
                var selectedRadioButton = $('input[name=cars]:checked', '#myForm').val();
                self.selectedRadioButton = selectedRadioButton;
                if (self.selectedRadioButton == 3) {
                    self.removeAllFiles();
                    self.docPaths = '';
                    self.isFileUploaded = true;
                }
            });

            $("#locationId").on('keyup', function () {
                self.locationError = '';
            });
            $("#categoryId").on('keyup', function () {
                self.categoryError = '';
            });
            $("#roleId").on('keyup', function () {
                self.roleError = '';
            });
            $("#videoURL").on('keyup', function () {
                self.videoURLError = '';
            });
            $("#videoTitle").on('keyup', function () {
                self.buttonTitleError = '';
            });

            $("#drop1").on('change', function () {
                self.videoURLError = '';
            });

            $("#alertError").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            /*if ($(".login-form-right-section").height() > $(window).height()) {
             $("#login-main-hr").height($(".login-form-right-section").height());
             } else {*/
            $("#login-main-hr").height($(window).height());
            /*}*/
            /*$("#login-main-hr").css({
             height:
             });*/

        },
        watch: {

        },
        methods: {
            changedValueLoc: function (value) {
                console.log(value);
            },
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listbenefitglance');
            },

            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
            },

            vfileSuccess: function (file, response) {
                self.docPaths = response.content.media_path;
                self.isFileUploaded = true;
                if ("media_thumb_path" in response.content) {
                } else {
                    /*console.log("No media thumb");*/
                }
                self.docType = file.type;
                self.docSize = file.size;
                self.videoURLError = '';
            },

            removedSelectedFile(file, xhr, error) {
                if(file && file.xhr && file.xhr.response){
                    self.docPaths = '';
                    self.docSize = '';
                    self.isFileUploaded = false;
                    self.isDocLoaded = false;
                    var filePath = JSON.parse(file.xhr.response);
                    //console.log(file);
                    if ("media_thumb_path" in filePath.content) {
                        self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                    } else {
                        self.removeFileFromServer(filePath.content.media_path, "");
                    }
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },

            /*changedValue: function (value) {
             //console.log(value);
             },*/

            changedValue: function (value) {
                //console.log(value);
            },
            changedCategoryFor: function () {
                self.categoryError = '';
            },
            onSearchCategory(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadCategory(loading, search, this);
                }
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                self.showLoader();
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    /*if (i == 1) {
                                     self.locationId = {
                                     value: response.data.content[i].value,
                                     text: response.data.content[i].text,
                                     };
                                     }*/
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                            /*self.locationArr = response.data.content;*/
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changedValueLocation: function () {
                self.locationError = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },

            loadLocations() {
                self.showLoader();
                HTTP.post("/getlocation")
                        .then(function (response) {
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    if (i == 1) {
                                        self.locationId = {
                                            value: response.data.content[i].value,
                                            text: response.data.content[i].text,
                                        };
                                    }
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                            /*self.locationArr = response.data.content;*/
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            checkForm: function () {
                var checked = true;
                if (!self.locationId) {
                    self.locationError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.selectedRadioButton == 2) {
                    if (!self.docPaths) {
                        self.videoURLError = "Please Upload Doc";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.fileUploaded == false) {
                    self.videoURLError = "Please Wait While Document Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.selectedRadioButton == 3) {
                    if (!self.videoURL) {
                        self.videoURLError = "Please Enter Button URL";
                        if (checked) {
                            checked = false;
                        }
                    } else if (!self.validUrl(self.videoURL)) {
                        self.videoURLError = 'Please Enter Valid URL';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (!self.videoTitle) {
                    self.buttonTitleError = "Button Title Required";
                    if (checked) {
                        checked = false;
                    }
                }


                return checked;
            },
            validUrl: function (url) {
                var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                return re.test(url);
            },

            loadBenefitGlance() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("getbenefitglance/" + segments[3], data, config)
                        .then(function (response) {
                            /*self.locationId = [];
                             for (var i = 0; i < response.data.content[0].location_name.length; i++) {
                             self.locationId.push({'text': response.data.content[0].location_name[i].name, 'value': response.data.content[0].location_name[i].id});
                             }*/
                            self.locationType = {'text': self.formatString(response.data.content[0].location_type), 'value': response.data.content[0].location_type};
                            self.locationId = {'text': response.data.content[0].location_name[0].name, 'value': response.data.content[0].location_name[0].id};
                            self.videoTitle = response.data.content[0].button_title;
                            var uploadedType = response.data.content[0].uploaded_type;

                            /*console.log(self.videoTitle);*/

                            if (uploadedType == 'upload') {
                                self.docPaths = response.data.content[0].doc_path;
                                self.selectedRadioButton = 2;
                                self.isFileUploaded = true;
                                self.isDocLoaded = true;
                                self.docSize = response.data.content[0].doc_size;
                                self.uploadManually();
                            }
                            if (uploadedType == 'url') {
                                self.selectedRadioButton = 3;
                                self.isFileUploaded = true;
                                self.videoURL = response.data.content[0].doc_path;
                                /*console.log("in if");*/
                                $('input:radio[name="cars"]').filter('[value="3"]').attr('checked', true);
                                $("#uploadSelected2").hide();
                                $("#uploadSelected3").show();
                                $(function () {
                                    /*console.log("in function");*/
                                    var $radios = $('input:radio[name=cars]');
                                    if ($radios.is(':checked') === false) {
                                        $radios.filter('[value=3]').prop('checked', true);
                                    }
                                });
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            uploadManually(file) {
                if (self.docPaths != '') {
                    var file_name = self.getFileName(self.docPaths);
                    let file_type = self.getFileType(file_name);
                    console.log("Hii",file_type);
                    let url = self.docPaths;
                    let file_size = self.docSize;
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                // return 'image/' + file_type;
                return 'application/' + file_type;
            },

            addBenefitGlance(flag) {
                /*console.log("Befor form check");*/
                self.checkForm();
                if (self.checkForm()) {
                    /*console.log("form check success");*/
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var locationsId = '';
                    /*for (var i = 0; i < self.locationId.length; i++) {
                     locationsId += (self.locationId[i].value) + ',';
                     }*/
                    locationsId += (self.locationId.value) + ',';
                    locationsId = locationsId.replace(/,\s*$/, "");

                    if (segments[2] == 'updatebenefitglance') {
                        if (segments[3]) {
                            if (self.isDocLoaded == true) {
                                self.docPaths = '';
                            }
                            var data = {
                                location_type: self.locationType.value,
                                locationId: locationsId,
                                videoTitle: self.videoTitle,
                                mediaPath: self.docPaths,
                                mediaType: self.docType,
                                mediaSize: self.docSize,
                                videoURL: self.videoURL,
                                uploadedType: self.selectedRadioButton,
                                id: segments[3],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            location_type: self.locationType.value,
                            locationId: locationsId,
                            videoTitle: self.videoTitle,
                            mediaPath: self.docPaths,
                            mediaType: self.docType,
                            mediaSize: self.docSize,
                            videoURL: self.videoURL,
                            uploadedType: self.selectedRadioButton,
                            id: segments[3],
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addbenefitglance", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatebenefitglance') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.status == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.locationId = [];
                                        self.locationType = '';
                                        self.videoTitle = '';
                                        self.videoURL = '';
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 3000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatebenefitglance') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            $(".alert-success").removeClass("hide");
                                            $(".alert-success").addClass("show");
                                            self.removeAllFiles();
                                            self.locationId = [];
                                            self.locationType = '';
                                            self.videoTitle = '';
                                            self.videoURL = '';

                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        $(".alert-success").removeClass("hide");
                                        $(".alert-success").addClass("show");
                                        self.removeAllFiles();
                                        self.locationId = [];
                                        self.locationType = '';
                                        self.videoTitle = '';
                                        self.videoURL = '';
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                value = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return value;
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.videoURLError = "";
                } else {
                    self.fileUploaded = false;
                }
            }
        }
    }
</script>

<style>
    .disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }
</style>



// WEBPACK FOOTER //
// src/components/backend/benefits/AddBenefitGlance.vue